import {Modal, ModalBody, ModalContent} from '@heroui/react';
import {useDictionary} from '@adamlip/okeoke.client';
import {useState} from 'react';
import {UserContext} from 'contexts/UserContext';
import {useContext} from 'react';
import toast from 'react-hot-toast';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import SendVibration from 'utils/Helpers-v1/SendVibration';

export default function ClaimPointModal({isOpen, setIsOpen, coupon}) {
	const {activateCoupon, refreshCoupons, userData} = useContext(UserContext);
	const [activateInProgress, setActivateInProgress] = useState('');
	const {getValue} = useDictionary();

	const handleActivateCoupon = () => {
		if (activateInProgress) return null;
		if (+userData?.points < +coupon?.claimPointCost) return null;
		setActivateInProgress(true);
		activateCoupon(coupon.code).then((response) => {
			if (response?.success) {
				toast.success(getValue('app_v2_coupons_activated'));
				refreshCoupons();
				setIsOpen(false);
				SendVibration('success');
			} else {
				toast.error(getValue('app_v2_coupons_activate_failed'));
			}
			setActivateInProgress(false);
		});
	};

	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={() => setIsOpen(!isOpen)}
			size='2xl'
			scrollBehavior='inside'
			classNames={{
				closeButton: 'z-50 bg-primary text-primary-foreground',
			}}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalBody>
							<div className=''>{getValue('app_v2_coupon_active_title')}</div>
							<div className=''>
								<div className='text-center'>{getValue('app_v2_coupon_active_cost')}</div>
								<div className='text-center text-large font-bold'>{coupon?.claimPointCost}</div>
								<div className='text-center italic text-sm'>{getValue('app_v2_coupon_active_desc')}</div>
								<div className='mt-2 text-sm text-center'>
									{getValue('app_v2_coupon_active_user_points')}
									{userData?.points}
								</div>
							</div>
							<BarSoftButton color='primary' onPress={() => handleActivateCoupon()} disabled={+userData?.points < +coupon?.claimPointCost}>
								{!activateInProgress && (
									<>
										{+userData?.points >= +coupon?.claimPointCost && getValue('app_v2_coupon_active_activate')}
										{+userData?.points < +coupon?.claimPointCost && getValue('app_v2_coupon_active_low_balance')}
									</>
								)}
								{activateInProgress && getValue('app_v2_coupon_code_add_inProgress')}
							</BarSoftButton>
						</ModalBody>
					</>
				)}
			</ModalContent>
		</Modal>
	);
}
